import axios from 'axios';

export async function sendRadioReport(radioId: number, report: number) {
  console.log(radioId);
  const data = await axios.post('http://137.74.92.81:8081/reportRadio', {radioId, report});
  console.log(data.data);
  return data.data;
}